import { CommApiInstance } from "Utils/CommApiInstance";




const AthnQrLoginUrlApi = async (
) => {
    return await CommApiInstance.post("athn/qr/login/url",{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default AthnQrLoginUrlApi;